/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Agentiq.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ChannelConnectionResponse,
  ChannelDeploymentResponse,
  ConnectorInstallResponse,
  OkResponse,
  SaveChannelConnectionRequest,
  SaveChannelDeploymentRequest,
  SaveConnectorInstallRequest,
  WhatsAppLinkRequest,
  WhatsAppLinkStartResponse,
  WhatsAppLinkStatusResponse
} from '../control-api.schemas';

import { orvalControlFetch } from '../../orval-fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getPostApiChannelConnectionsUrl = () => {




  return `/api/channel-connections`
}

export const postApiChannelConnections = async (saveChannelConnectionRequest: SaveChannelConnectionRequest, options?: RequestInit): Promise<ChannelConnectionResponse> => {

  return orvalControlFetch<ChannelConnectionResponse>(getPostApiChannelConnectionsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saveChannelConnectionRequest,)
  }
);}




export const getPostApiChannelConnectionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChannelConnections>>, TError,{data: SaveChannelConnectionRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiChannelConnections>>, TError,{data: SaveChannelConnectionRequest}, TContext> => {

const mutationKey = ['postApiChannelConnections'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiChannelConnections>>, {data: SaveChannelConnectionRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiChannelConnections(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiChannelConnectionsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiChannelConnections>>>
    export type PostApiChannelConnectionsMutationBody = SaveChannelConnectionRequest
    export type PostApiChannelConnectionsMutationError = unknown

    export const usePostApiChannelConnections = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChannelConnections>>, TError,{data: SaveChannelConnectionRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiChannelConnections>>,
        TError,
        {data: SaveChannelConnectionRequest},
        TContext
      > => {
      return useMutation(getPostApiChannelConnectionsMutationOptions(options), queryClient);
    }
    export const getGetApiChannelConnectionsUrl = () => {




  return `/api/channel-connections`
}

export const getApiChannelConnections = async ( options?: RequestInit): Promise<ChannelConnectionResponse[]> => {

  return orvalControlFetch<ChannelConnectionResponse[]>(getGetApiChannelConnectionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiChannelConnectionsQueryKey = () => {
    return [
    `/api/channel-connections`
    ] as const;
    }


export const getGetApiChannelConnectionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiChannelConnections>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChannelConnections>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiChannelConnectionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChannelConnections>>> = ({ signal }) => getApiChannelConnections({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiChannelConnections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiChannelConnectionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChannelConnections>>>
export type GetApiChannelConnectionsQueryError = unknown


export function useGetApiChannelConnections<TData = Awaited<ReturnType<typeof getApiChannelConnections>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChannelConnections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiChannelConnections>>,
          TError,
          Awaited<ReturnType<typeof getApiChannelConnections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiChannelConnections<TData = Awaited<ReturnType<typeof getApiChannelConnections>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChannelConnections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiChannelConnections>>,
          TError,
          Awaited<ReturnType<typeof getApiChannelConnections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiChannelConnections<TData = Awaited<ReturnType<typeof getApiChannelConnections>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChannelConnections>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiChannelConnections<TData = Awaited<ReturnType<typeof getApiChannelConnections>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChannelConnections>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiChannelConnectionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetApiChannelConnectionsIdUrl = (id: string,) => {




  return `/api/channel-connections/${id}`
}

export const getApiChannelConnectionsId = async (id: string, options?: RequestInit): Promise<ChannelConnectionResponse> => {

  return orvalControlFetch<ChannelConnectionResponse>(getGetApiChannelConnectionsIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiChannelConnectionsIdQueryKey = (id: string,) => {
    return [
    `/api/channel-connections/${id}`
    ] as const;
    }


export const getGetApiChannelConnectionsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiChannelConnectionsId>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChannelConnectionsId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiChannelConnectionsIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChannelConnectionsId>>> = ({ signal }) => getApiChannelConnectionsId(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiChannelConnectionsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiChannelConnectionsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChannelConnectionsId>>>
export type GetApiChannelConnectionsIdQueryError = unknown


export function useGetApiChannelConnectionsId<TData = Awaited<ReturnType<typeof getApiChannelConnectionsId>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChannelConnectionsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiChannelConnectionsId>>,
          TError,
          Awaited<ReturnType<typeof getApiChannelConnectionsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiChannelConnectionsId<TData = Awaited<ReturnType<typeof getApiChannelConnectionsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChannelConnectionsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiChannelConnectionsId>>,
          TError,
          Awaited<ReturnType<typeof getApiChannelConnectionsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiChannelConnectionsId<TData = Awaited<ReturnType<typeof getApiChannelConnectionsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChannelConnectionsId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiChannelConnectionsId<TData = Awaited<ReturnType<typeof getApiChannelConnectionsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChannelConnectionsId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiChannelConnectionsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getDeleteApiChannelConnectionsIdUrl = (id: string,) => {




  return `/api/channel-connections/${id}`
}

export const deleteApiChannelConnectionsId = async (id: string, options?: RequestInit): Promise<OkResponse> => {

  return orvalControlFetch<OkResponse>(getDeleteApiChannelConnectionsIdUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiChannelConnectionsIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiChannelConnectionsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiChannelConnectionsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteApiChannelConnectionsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiChannelConnectionsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiChannelConnectionsId(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiChannelConnectionsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiChannelConnectionsId>>>

    export type DeleteApiChannelConnectionsIdMutationError = unknown

    export const useDeleteApiChannelConnectionsId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiChannelConnectionsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiChannelConnectionsId>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteApiChannelConnectionsIdMutationOptions(options), queryClient);
    }
    export const getPostApiChannelDeploymentsUrl = () => {




  return `/api/channel-deployments`
}

export const postApiChannelDeployments = async (saveChannelDeploymentRequest: SaveChannelDeploymentRequest, options?: RequestInit): Promise<ChannelDeploymentResponse> => {

  return orvalControlFetch<ChannelDeploymentResponse>(getPostApiChannelDeploymentsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saveChannelDeploymentRequest,)
  }
);}




export const getPostApiChannelDeploymentsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChannelDeployments>>, TError,{data: SaveChannelDeploymentRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiChannelDeployments>>, TError,{data: SaveChannelDeploymentRequest}, TContext> => {

const mutationKey = ['postApiChannelDeployments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiChannelDeployments>>, {data: SaveChannelDeploymentRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiChannelDeployments(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiChannelDeploymentsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiChannelDeployments>>>
    export type PostApiChannelDeploymentsMutationBody = SaveChannelDeploymentRequest
    export type PostApiChannelDeploymentsMutationError = unknown

    export const usePostApiChannelDeployments = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChannelDeployments>>, TError,{data: SaveChannelDeploymentRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiChannelDeployments>>,
        TError,
        {data: SaveChannelDeploymentRequest},
        TContext
      > => {
      return useMutation(getPostApiChannelDeploymentsMutationOptions(options), queryClient);
    }
    export const getGetApiChannelDeploymentsUrl = () => {




  return `/api/channel-deployments`
}

export const getApiChannelDeployments = async ( options?: RequestInit): Promise<ChannelDeploymentResponse[]> => {

  return orvalControlFetch<ChannelDeploymentResponse[]>(getGetApiChannelDeploymentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiChannelDeploymentsQueryKey = () => {
    return [
    `/api/channel-deployments`
    ] as const;
    }


export const getGetApiChannelDeploymentsQueryOptions = <TData = Awaited<ReturnType<typeof getApiChannelDeployments>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChannelDeployments>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiChannelDeploymentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChannelDeployments>>> = ({ signal }) => getApiChannelDeployments({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiChannelDeployments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiChannelDeploymentsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChannelDeployments>>>
export type GetApiChannelDeploymentsQueryError = unknown


export function useGetApiChannelDeployments<TData = Awaited<ReturnType<typeof getApiChannelDeployments>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChannelDeployments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiChannelDeployments>>,
          TError,
          Awaited<ReturnType<typeof getApiChannelDeployments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiChannelDeployments<TData = Awaited<ReturnType<typeof getApiChannelDeployments>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChannelDeployments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiChannelDeployments>>,
          TError,
          Awaited<ReturnType<typeof getApiChannelDeployments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiChannelDeployments<TData = Awaited<ReturnType<typeof getApiChannelDeployments>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChannelDeployments>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiChannelDeployments<TData = Awaited<ReturnType<typeof getApiChannelDeployments>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChannelDeployments>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiChannelDeploymentsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetApiChannelDeploymentsIdUrl = (id: string,) => {




  return `/api/channel-deployments/${id}`
}

export const getApiChannelDeploymentsId = async (id: string, options?: RequestInit): Promise<ChannelDeploymentResponse> => {

  return orvalControlFetch<ChannelDeploymentResponse>(getGetApiChannelDeploymentsIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiChannelDeploymentsIdQueryKey = (id: string,) => {
    return [
    `/api/channel-deployments/${id}`
    ] as const;
    }


export const getGetApiChannelDeploymentsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiChannelDeploymentsId>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChannelDeploymentsId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiChannelDeploymentsIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChannelDeploymentsId>>> = ({ signal }) => getApiChannelDeploymentsId(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiChannelDeploymentsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiChannelDeploymentsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChannelDeploymentsId>>>
export type GetApiChannelDeploymentsIdQueryError = unknown


export function useGetApiChannelDeploymentsId<TData = Awaited<ReturnType<typeof getApiChannelDeploymentsId>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChannelDeploymentsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiChannelDeploymentsId>>,
          TError,
          Awaited<ReturnType<typeof getApiChannelDeploymentsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiChannelDeploymentsId<TData = Awaited<ReturnType<typeof getApiChannelDeploymentsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChannelDeploymentsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiChannelDeploymentsId>>,
          TError,
          Awaited<ReturnType<typeof getApiChannelDeploymentsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiChannelDeploymentsId<TData = Awaited<ReturnType<typeof getApiChannelDeploymentsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChannelDeploymentsId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiChannelDeploymentsId<TData = Awaited<ReturnType<typeof getApiChannelDeploymentsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChannelDeploymentsId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiChannelDeploymentsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getDeleteApiChannelDeploymentsIdUrl = (id: string,) => {




  return `/api/channel-deployments/${id}`
}

export const deleteApiChannelDeploymentsId = async (id: string, options?: RequestInit): Promise<OkResponse> => {

  return orvalControlFetch<OkResponse>(getDeleteApiChannelDeploymentsIdUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiChannelDeploymentsIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiChannelDeploymentsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiChannelDeploymentsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteApiChannelDeploymentsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiChannelDeploymentsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiChannelDeploymentsId(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiChannelDeploymentsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiChannelDeploymentsId>>>

    export type DeleteApiChannelDeploymentsIdMutationError = unknown

    export const useDeleteApiChannelDeploymentsId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiChannelDeploymentsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiChannelDeploymentsId>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteApiChannelDeploymentsIdMutationOptions(options), queryClient);
    }
    export const getPostApiConnectorInstallsUrl = () => {




  return `/api/connector-installs`
}

export const postApiConnectorInstalls = async (saveConnectorInstallRequest: SaveConnectorInstallRequest, options?: RequestInit): Promise<ConnectorInstallResponse> => {

  return orvalControlFetch<ConnectorInstallResponse>(getPostApiConnectorInstallsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saveConnectorInstallRequest,)
  }
);}




export const getPostApiConnectorInstallsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorInstalls>>, TError,{data: SaveConnectorInstallRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorInstalls>>, TError,{data: SaveConnectorInstallRequest}, TContext> => {

const mutationKey = ['postApiConnectorInstalls'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiConnectorInstalls>>, {data: SaveConnectorInstallRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiConnectorInstalls(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiConnectorInstallsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiConnectorInstalls>>>
    export type PostApiConnectorInstallsMutationBody = SaveConnectorInstallRequest
    export type PostApiConnectorInstallsMutationError = unknown

    export const usePostApiConnectorInstalls = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiConnectorInstalls>>, TError,{data: SaveConnectorInstallRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiConnectorInstalls>>,
        TError,
        {data: SaveConnectorInstallRequest},
        TContext
      > => {
      return useMutation(getPostApiConnectorInstallsMutationOptions(options), queryClient);
    }
    export const getGetApiConnectorInstallsUrl = () => {




  return `/api/connector-installs`
}

export const getApiConnectorInstalls = async ( options?: RequestInit): Promise<ConnectorInstallResponse[]> => {

  return orvalControlFetch<ConnectorInstallResponse[]>(getGetApiConnectorInstallsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiConnectorInstallsQueryKey = () => {
    return [
    `/api/connector-installs`
    ] as const;
    }


export const getGetApiConnectorInstallsQueryOptions = <TData = Awaited<ReturnType<typeof getApiConnectorInstalls>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorInstalls>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiConnectorInstallsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiConnectorInstalls>>> = ({ signal }) => getApiConnectorInstalls({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorInstalls>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiConnectorInstallsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiConnectorInstalls>>>
export type GetApiConnectorInstallsQueryError = unknown


export function useGetApiConnectorInstalls<TData = Awaited<ReturnType<typeof getApiConnectorInstalls>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorInstalls>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiConnectorInstalls>>,
          TError,
          Awaited<ReturnType<typeof getApiConnectorInstalls>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiConnectorInstalls<TData = Awaited<ReturnType<typeof getApiConnectorInstalls>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorInstalls>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiConnectorInstalls>>,
          TError,
          Awaited<ReturnType<typeof getApiConnectorInstalls>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiConnectorInstalls<TData = Awaited<ReturnType<typeof getApiConnectorInstalls>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorInstalls>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiConnectorInstalls<TData = Awaited<ReturnType<typeof getApiConnectorInstalls>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorInstalls>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiConnectorInstallsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getGetApiConnectorInstallsIdUrl = (id: string,) => {




  return `/api/connector-installs/${id}`
}

export const getApiConnectorInstallsId = async (id: string, options?: RequestInit): Promise<ConnectorInstallResponse> => {

  return orvalControlFetch<ConnectorInstallResponse>(getGetApiConnectorInstallsIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiConnectorInstallsIdQueryKey = (id: string,) => {
    return [
    `/api/connector-installs/${id}`
    ] as const;
    }


export const getGetApiConnectorInstallsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiConnectorInstallsId>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorInstallsId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiConnectorInstallsIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiConnectorInstallsId>>> = ({ signal }) => getApiConnectorInstallsId(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorInstallsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiConnectorInstallsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiConnectorInstallsId>>>
export type GetApiConnectorInstallsIdQueryError = unknown


export function useGetApiConnectorInstallsId<TData = Awaited<ReturnType<typeof getApiConnectorInstallsId>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorInstallsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiConnectorInstallsId>>,
          TError,
          Awaited<ReturnType<typeof getApiConnectorInstallsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiConnectorInstallsId<TData = Awaited<ReturnType<typeof getApiConnectorInstallsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorInstallsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiConnectorInstallsId>>,
          TError,
          Awaited<ReturnType<typeof getApiConnectorInstallsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiConnectorInstallsId<TData = Awaited<ReturnType<typeof getApiConnectorInstallsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorInstallsId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiConnectorInstallsId<TData = Awaited<ReturnType<typeof getApiConnectorInstallsId>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiConnectorInstallsId>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiConnectorInstallsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getDeleteApiConnectorInstallsIdUrl = (id: string,) => {




  return `/api/connector-installs/${id}`
}

export const deleteApiConnectorInstallsId = async (id: string, options?: RequestInit): Promise<OkResponse> => {

  return orvalControlFetch<OkResponse>(getDeleteApiConnectorInstallsIdUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiConnectorInstallsIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiConnectorInstallsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiConnectorInstallsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteApiConnectorInstallsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiConnectorInstallsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiConnectorInstallsId(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiConnectorInstallsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiConnectorInstallsId>>>

    export type DeleteApiConnectorInstallsIdMutationError = unknown

    export const useDeleteApiConnectorInstallsId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiConnectorInstallsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiConnectorInstallsId>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteApiConnectorInstallsIdMutationOptions(options), queryClient);
    }
    export const getPostApiChannelsWhatsappLinkStartUrl = () => {




  return `/api/channels/whatsapp/link/start`
}

export const postApiChannelsWhatsappLinkStart = async (whatsAppLinkRequest: WhatsAppLinkRequest, options?: RequestInit): Promise<WhatsAppLinkStartResponse> => {

  return orvalControlFetch<WhatsAppLinkStartResponse>(getPostApiChannelsWhatsappLinkStartUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      whatsAppLinkRequest,)
  }
);}




export const getPostApiChannelsWhatsappLinkStartMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChannelsWhatsappLinkStart>>, TError,{data: WhatsAppLinkRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiChannelsWhatsappLinkStart>>, TError,{data: WhatsAppLinkRequest}, TContext> => {

const mutationKey = ['postApiChannelsWhatsappLinkStart'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiChannelsWhatsappLinkStart>>, {data: WhatsAppLinkRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiChannelsWhatsappLinkStart(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiChannelsWhatsappLinkStartMutationResult = NonNullable<Awaited<ReturnType<typeof postApiChannelsWhatsappLinkStart>>>
    export type PostApiChannelsWhatsappLinkStartMutationBody = WhatsAppLinkRequest
    export type PostApiChannelsWhatsappLinkStartMutationError = unknown

    export const usePostApiChannelsWhatsappLinkStart = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChannelsWhatsappLinkStart>>, TError,{data: WhatsAppLinkRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiChannelsWhatsappLinkStart>>,
        TError,
        {data: WhatsAppLinkRequest},
        TContext
      > => {
      return useMutation(getPostApiChannelsWhatsappLinkStartMutationOptions(options), queryClient);
    }
    export const getPostApiChannelsWhatsappLinkStatusUrl = () => {




  return `/api/channels/whatsapp/link/status`
}

export const postApiChannelsWhatsappLinkStatus = async (whatsAppLinkRequest: WhatsAppLinkRequest, options?: RequestInit): Promise<WhatsAppLinkStatusResponse> => {

  return orvalControlFetch<WhatsAppLinkStatusResponse>(getPostApiChannelsWhatsappLinkStatusUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      whatsAppLinkRequest,)
  }
);}




export const getPostApiChannelsWhatsappLinkStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChannelsWhatsappLinkStatus>>, TError,{data: WhatsAppLinkRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiChannelsWhatsappLinkStatus>>, TError,{data: WhatsAppLinkRequest}, TContext> => {

const mutationKey = ['postApiChannelsWhatsappLinkStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiChannelsWhatsappLinkStatus>>, {data: WhatsAppLinkRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiChannelsWhatsappLinkStatus(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiChannelsWhatsappLinkStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postApiChannelsWhatsappLinkStatus>>>
    export type PostApiChannelsWhatsappLinkStatusMutationBody = WhatsAppLinkRequest
    export type PostApiChannelsWhatsappLinkStatusMutationError = unknown

    export const usePostApiChannelsWhatsappLinkStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiChannelsWhatsappLinkStatus>>, TError,{data: WhatsAppLinkRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiChannelsWhatsappLinkStatus>>,
        TError,
        {data: WhatsAppLinkRequest},
        TContext
      > => {
      return useMutation(getPostApiChannelsWhatsappLinkStatusMutationOptions(options), queryClient);
    }
